/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * INosBusinessSignUp containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export interface INosBusinessSignUpConfig extends Msdyn365.IModuleConfig {
    heading: IHeadingData;
    confirmationLink: IConfirmationLinkData;
    className?: string;
    clientRender?: boolean;
    azureMapsSuggestionLimit: number;
}

export interface INosBusinessSignUpResources {
    firstNameLabel: string;
    firstNameMaxLength: string;
    salutationLabel: string;
    lastNameLabel: string;
    lastNameMaxLength: string;
    emailAddressLabel: string;
    phoneLabelText: string;
    phoneMaxLength: string;
    companyLabel: string;
    companyMaxLength: string;
    companyAddressLabel: string;
    companyAddressMaxLength: string;
    jobTitleLabel: string;
    jobTitleMaxLength: string;
    departmentLabel: string;
    departmentMaxLength: string;
    companySizeLabel: string;
    companySizeMaxLength: string;
    commentLabel: string;
    commentMaxLength: string;
    errorMessage: string;
    signUpButtonText: string;
    signUpButtonArialabel: string;
    cancelButtonText: string;
    cancelButtonArialabel: string;
    requiredFieldMissingSummaryError: string;
    requiredFieldMissingError: string;
    fieldIncorrectError: string;
    partialAddressErrorMessage: string;
    vatLabel: string;
    vat: string;
    vatValidateButton: string;
    vatRevalidateButton: string;
    withoutVatCheckbox: string;
    countrySelect: string;
    languageSelectLabel: string;
    companyTypeLabel: string;
    additionalAddressLabel: string;
    emailSectionHeader: string;
    emailSectionHeaderLabel: string;
    vatIdSectionHeader: string;
    vatIdSectionHeaderLabel: string;
    personalSectionHeader: string;
    personalSectionHeaderLabel: string;
    companySectionHeader: string;
    companySectionHeaderLabel: string;
    exisitingCustomerNumberLabel: string;
    verifyEmailLabel: string;
    streetLabel: string;
    numberLabel: string;
    zipLabel: string;
    cityLabel: string;
    vatIdValid: string;
    vatIdNotValid: string;
    continueWithoutVatOrValidate: string;
    youWillBeChargedVat: string;
    uncheckToContinueWithValidVat: string;
    emailVerified: string;
    emailVerificationFailed: string;
    verificationPending: string;
    isUserExisting: string;
    emailCodeHasBeenSent: string;
    verifyEmailCodeLabel: string;
    pleaseEnterVerificationCode: string;
    select: string;
    sendEmailVerificationLabel: string;
    confirmEmailCodeButtonLabel: string;
    vatIdFailed: string;
    termsAndConditions: string;
    termsAndConditionsValidate: string;
    signInLinkText: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface IConfirmationLinkData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface INosBusinessSignUpProps<T> extends Msdyn365.IModule<T> {
    resources: INosBusinessSignUpResources;
    config: INosBusinessSignUpConfig;
    slots: {
        languageSlot: React.ReactNode[];
        countrySlot: React.ReactNode[];
        companyTypeSlot: React.ReactNode[];
        phoneSlot: React.ReactNode[];
    };
}
